import { useEffect, useState } from 'react';
import useFormatDocuments from '../../hooks/useFormatDocuments';
import { ClientProps, ErrorProps, OffersProps } from '../../types/types';
import { API } from '../../services/api';
import { useRenewal } from '../../context/RenewalContext';
import Loading from '../../components/Loading';
import OffersList from '../../components/OffersList';
import PageError from '../../components/PageError';
import {
  Container,
  Title,
  Paragraph,
  List,
  ListItem,
  OffersTypeButtonsGroup,
  Button,
} from './styles';

const Renewal = () => {
  const [client, setClient] = useState<ClientProps | null>(null);
  const [offers, setOffers] = useState<OffersProps | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<ErrorProps | null>(null);
  const [selectedOfferType, setSelectedOfferType] = useState<string>('');
  const { setData } = useRenewal();

  const getParamsFromSession = () => {
    const storedParams = sessionStorage.getItem('urlParams');
    return storedParams ? JSON.parse(storedParams) : {};
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await API.request('/api/v1/offer', {
          method: 'GET',
        });
        setClient(response.client || null);
        setOffers(response.offers || null);
        setSelectedOfferType(Object.keys(response.offers)[0]);
      } catch (error) {
        setError(error as ErrorProps);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const { formattedCpf, formattedCnpj } = useFormatDocuments(client?.cpf, client?.cnpj);
  const offerTypes = offers ? Object.keys(offers) : [];
  
  useEffect(() => {
    const {
      group = '',
      codrev = '',
      ar = ''
    } = getParamsFromSession();

    setData((prevData) => ({
      ...prevData,
      requestInfo: {
        ...prevData.requestInfo,
        grupo: group,
        codRev: codrev,
        ar: ar,
      }
    }));
  }, [setData]);

  return (
    <Container>
      {loading && <Loading loading={loading} />}
      {!loading && error && (
        <PageError error={error} />
      )}

      {!loading && !error && (
        <>
          <Title>Conferência dos dados</Title>
          <Paragraph>Confira os dados do certificado digital. Eles serão utilizados para a renovação.</Paragraph>
          {client && (
            <List>
              <ListItem>Titular: {client.name}</ListItem>
              <ListItem>CPF: {formattedCpf}</ListItem>
              {formattedCnpj && <ListItem>CNPJ: {formattedCnpj}</ListItem>}
            </List>
          )}

          <OffersTypeButtonsGroup>
            {offerTypes.map((type) => (
              <Button
                key={type}
                $isActive={selectedOfferType === type}
                $hasNewPurchase={offerTypes.length > 2}
                onClick={() => setSelectedOfferType(type)}
              >
                {type === 'RENEWAL' ? 'Renovação' :
                  type === 'PORTABILITY' ? 'Portabilidade (Compra fácil)' :
                    type === 'NEW_PURCHASE' ? 'Nova Compra' :
                      type}
              </Button>
            ))}
          </OffersTypeButtonsGroup>

          {offers && offers[selectedOfferType] && (
            <OffersList clientInfos={client} offersByCategory={offers[selectedOfferType]} />
          )}
        </>
      )}
    </Container>
  );
};

export default Renewal;
